export default "__VITE_ASSET__C5r3amrC__"